var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"w-6 h-6 inline-block",attrs:{"src":"/imgs/mpay.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }